import {
  CustomInputSelect,
  CustomTextInput
} from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { TAuthorizationsConsultationDataTableData } from '@Modules/admin/archiving/containers/mixedHandlers/archivedTables/authorizationsConsultation/AuthorizationsConsultationDatatableMeta';
import { IAuthorizationsConsultationDataTableRowFormMeta } from '@Modules/admin/archiving/containers/mixedHandlers/archivedTables/authorizationsConsultation/AuthorizationsConsultationDatatableRowMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
type Props = {
    meta: IAuthorizationsConsultationDataTableRowFormMeta,
    data: TAuthorizationsConsultationDataTableData
} & TFormUIProps;

export default React.forwardRef(function AuthorizationsConsultationTableFormUI ({ onSubmit, isLoading, isSubmitting, meta, data }: Props, ref: any) {

  const submitBtnRef = React.useRef<HTMLButtonElement>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ 
    defaultValues: data,
    resolver: yupResolver(meta.schema) 
  });

  React.useImperativeHandle(ref, () => ({
    submitBtnRef
  }));

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)} ref={ref}>

      <CC.SimpleGrid columns={{base: 1, md: 2, lg:3}} spacing={10} my={10}>

        <CustomFormControl
          label={meta.oneDate.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.oneDate.name]}
        >
          <CustomTextInput
            meta={meta.oneDate}
            register={register(meta.oneDate.name)}
            hasError={errors[meta.oneDate.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.authorizationNumber.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.authorizationNumber.name]}
        >
          <CustomTextInput
            meta={meta.authorizationNumber}
            register={register(meta.authorizationNumber.name)}
            hasError={errors[meta.authorizationNumber.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.PAN.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.PAN.name]}
        >
          <CustomTextInput
            meta={meta.PAN}
            register={register(meta.PAN.name)}
            hasError={errors[meta.PAN.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.dateExp.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.dateExp.name]}
        >
          <CustomTextInput
            meta={meta.dateExp}
            register={register(meta.dateExp.name)}
            hasError={errors[meta.dateExp.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.amount.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.amount.name]}
        >
          <CustomTextInput
            meta={meta.amount}
            register={register(meta.amount.name)}
            hasError={errors[meta.amount.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.mon.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.mon.name]}
        >
          <CustomTextInput
            meta={meta.mon}
            register={register(meta.mon.name)}
            hasError={errors[meta.mon.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.repo.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.repo.name]}
        >
          <CustomTextInput
            meta={meta.repo}
            register={register(meta.repo.name)}
            hasError={errors[meta.repo.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.status.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.status.name]}
        >
          <CustomTextInput
            meta={meta.status}
            register={register(meta.status.name)}
            hasError={errors[meta.status.name]}
          />
        </CustomFormControl>

        <CustomFormControl
          label={meta.statA.label}
          isLoading={isLoading}
          isInvalid={!!errors[meta.statA.name]}
        >
          <CustomTextInput
            meta={meta.statA}
            register={register(meta.statA.name)}
            hasError={errors[meta.statA.name]}
          />
        </CustomFormControl>

      </CC.SimpleGrid>  
      
      <button type={'submit'} ref={submitBtnRef} style={{display: "none"}}>
        Enregistrer
      </button>
    </CC.Box>
  );
});

// export default AuthorizationsConsultationFormUI;
